<template>
  <div>
    <v-navigation-drawer v-model="drawer" :width="215" app>
      <div class="hidden">
        <vs-sidebar absolute v-model="active" open style="width: 215px">
          <v-sidebar-item class="d-flex align-center mb-3" align="center" >
            <vs-avatar  class="ml-4 mt-2 rounded-xl" >
              <img v-if="roleName != 'Super Admin'"  :src="mediaUrl + user.companies[0]?.logo_path"  alt="Logo">
              <img v-else  src="https://blr1.vultrobjects.com/space-1//azrms/company/1/photo1710745622.jpg"   alt="">
            </vs-avatar>
            <span class="ml-3 text-caption" v-if="roleName != 'Super Admin'" > <span class="font-weight-bold"> {{ user.companies[0]?.name }} </span><br> <span>Hello! {{ roleName }}</span> </span>
            <span class="ml-3 text-caption" v-else> <span class="font-weight-bold"> Azrms </span><br> <span>Hello! Super Admin</span> </span>
          </v-sidebar-item>
          <vs-sidebar-item id="profile" v-if="roleName != 'Super Admin'" :to="`/profile/${user.id}`">
            <template #icon>
              <i class="mdi mdi-account"></i>
            </template>
            My Profile
          </vs-sidebar-item>
          <vs-sidebar-item v-if="roleName == 'Super Admin'" id="permission" :to="`/permissions`">
            <template #icon>
              <i class="mdi mdi-lock-check-outline"></i>
            </template>
            Permission
          </vs-sidebar-item>
          <vs-sidebar-item v-if="roleName == 'Super Admin'" id="companies" :to="`/companies`">
            <template #icon>
              <i class="mdi mdi-office-building"></i>
            </template>
            Companies
          </vs-sidebar-item>
          <span @click="openNotification('top-right')">
            <vs-sidebar-item
              id="home"
              :to="companyId != null ? `/home` : `/settings`"
            >
            <template #icon>
              <i class="mdi mdi-home"></i>
            </template>
            Home
          </vs-sidebar-item>
          </span>
          <span @click="openNotification('top-right')">
            <vs-sidebar-item v-if="roleName != 'User'" 
              id="users"
              :to="companyId != null ? `/users` : `/settings`"
            >
              <template #icon>
                <i class="mdi mdi-account-child"></i>
              </template>
              Users
            </vs-sidebar-item>
          </span>
          <span @click="openNotification('top-right')">
            <vs-sidebar-item
              id="units"
              :to="companyId != null ? `/units` : `/settings`"
            >
              <template #icon>
                <i class="mdi mdi-unity"></i>
              </template>
              Units
            </vs-sidebar-item>
          </span>
          <vs-sidebar-group>
            <template #header>
              <vs-sidebar-item arrow>
                <template #icon>
                  <i class="mdi mdi-cog-play"></i>
                </template>
                Settings
              </vs-sidebar-item>
            </template>
            <vs-sidebar-item id="values" :to="`/values`">
              <template #icon>
                <i class="mdi mdi-alphabet-piqad"></i>
              </template>
              Value / Value-List
            </vs-sidebar-item>
            <vs-sidebar-item
              v-if="roleName == 'Super Admin'"
              id="head-pump-sizes"
              :to="`/head-pump-sizes`"
            >
              <template #icon>
                <i class="mdi mdi-pump"></i>
              </template>
              Head Pump Sizes
            </vs-sidebar-item>
            <vs-sidebar-item
              v-if="roleName == 'Super Admin'"
              id="redis-monitor"
              :to="`/redis-monitor`"
            >
              <template #icon>
                <i class="mdi mdi-database-eye"></i>
              </template>
              Redis Monitor
            </vs-sidebar-item>
            <vs-sidebar-item
              v-if="roleName == 'Super Admin'"
              id="settings"
              :to="`/settings`"
            >
              <template #icon>
                <i :class="`mdi mdi-home`"></i>
              </template>
              Organizations
            </vs-sidebar-item>
          </vs-sidebar-group>

          <template #footer>
            <vs-row justify="space-between">
              <vs-button color="#6c5dd4" block @click="logout">
                Logout
              </vs-button>
            </vs-row>
          </template>
        </vs-sidebar>
      </div>
    </v-navigation-drawer>

    <v-app-bar
      color="white"
      elevation="0"
      class="d-flex align-center"
      height="52"
      app
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn class="text-caption"  text>
        {{ user.name != null ? user.name : user.email }}
        [ {{ roleName }}] [{{ roleName != 'Super Admin' ? user.companies[0]?.name : 'Azrms' }}]
      </v-btn>
      <v-icon v-if="$vuetify.breakpoint.smAndDown" class="float-end" @click="logout">mdi-logout</v-icon>
    </v-app-bar>

    <router-view />
  </div>
</template>

<script type="text/javascript">
import { mapActions } from "vuex";

export default {
  data() {
    return {
      drawer: true,
      companyName: "",
      active: "",
    };
  },
  computed: {
    companyId() {
      if (this.roleName === "Super Admin") {
        return this.$store.getters["settings/getCompanyId"];
      } else {
        return this.user.companies[0]?.id;
      }
    },
  },
  created() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    }
    this.active = this.$route.path.substring(1);
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
    openNotification(position = null) {
      if (this.roleName == "Super Admin" && this.companyId == null) {
        this.$vs.notification({
          position,
          title: "<span style='color: red'>Please select any company</span>",
          text: `You need to select a company to get acces to the users , admins and units`,
        });
      }
    },
  },
};
</script>

<style>
.vs-sidebar__logo {
  padding-top: 0px !important;
}
.vs-sidebar__item__arrow {
  position: absolute;
  right: 50px;
}
</style>
